const { filter, get, some } = require('lodash');
const hasConditionsForQuestion = (it, questionId) => {
    return filter(it.conditions, condition => {
        return some(condition.query.where, where => {
            return get(where, 'attribute.value.id', false) === questionId;
        });
    }).length > 0;
};
module.exports = hasConditionsForQuestion;
